import { Card, Typography, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getPreScreeningQuestions } from 'src/services/candidate.service';
import EmptyContent from 'src/components/empty-content';
import { PRE_SCREENING_RESPONSE_TYPES } from 'src/constants/job-candidate';

const BOOLEAN_TYPES = {
  TRUE: 'Yes',
  FALSE: 'No',
};

const PreScreening = ({ jobId, candidateDetails }) => {
  // states
  const [preScreeningDetails, setPreScreeningDetails] = useState(null);

  // functions
  const getAnswer = question => {
    if (
      preScreeningDetails.solutions &&
      preScreeningDetails.solutions.find(
        solution => solution.question_id === question.question_id,
      )
    ) {
      if (question.response_type === PRE_SCREENING_RESPONSE_TYPES.BOOLEAN) {
        const responseText = preScreeningDetails.solutions.find(
          solution => solution.question_id === question.question_id,
        ).response_text;

        return BOOLEAN_TYPES[responseText];
      }
      return preScreeningDetails.solutions.find(
        solution => solution.question_id === question.question_id,
      ).response_text;
    }
    return '';
  };

  // effects
  useEffect(() => {
    if (jobId && candidateDetails.candidate_info.user_id)
      getPreScreeningQuestions(jobId, candidateDetails.candidate_info.user_id)
        .then(res => {
          if (res.success) {
            setPreScreeningDetails(res.body);
          }
        })
        .catch(err => console.log(err));
  }, [candidateDetails, candidateDetails.candidate_info.user_id, jobId]);

  return (
    <Card sx={{ p: 3 }}>
      {preScreeningDetails ? (
        <Stack spacing={3}>
          {preScreeningDetails.questions &&
            preScreeningDetails.questions.map(question => (
              <Stack key={question.sl_no} spacing={0.5}>
                <Typography variant="caption">
                  Question {question.sl_no}
                </Typography>
                <Stack>
                  <Typography variant="body1" fontWeight={600}>
                    {question.text}
                  </Typography>
                  <Typography variant="body1">{getAnswer(question)}</Typography>
                </Stack>
              </Stack>
            ))}
        </Stack>
      ) : (
        <EmptyContent
          filled
          title="No Pre-screening Data"
          sx={{
            py: 10,
          }}
        />
      )}
    </Card>
  );
};

PreScreening.propTypes = {
  jobId: PropTypes.string,
  candidateDetails: PropTypes.object,
};

export default PreScreening;
